import script from "./SortDSC.vue?vue&type=script&setup=true&lang=js"
export * from "./SortDSC.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__